<div class="empty-content">
  <div class="text-container" *ngIf="isEmpty">
    <img
      src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
      alt="Empty images">
    <h1>Attachment cannot be opened</h1>
    <div class="text">Please open the <a (click)='navigateToTaskManager()'>Task Manager</a> and find the task to
      open
      the attachment
    </div>
  </div>
</div>
<div id="entityDataGrid" *ngIf="!isEmpty" class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" (selectionChanged)="breadcrumbChanged($event)"
                            (dropDownSelectionChanged)="onDropDownSelection($event)"></particle-breadcrumbs>
    </div>
    <div class="flex flex-row justify-start items-center" *ngIf="!isItemFormView">
      <div class="avatar-container flex flex-row justify-end items-center" *ngIf="responseId">
        <particle-user-activity [endpoint]="endpointName" [sourceId]="responseId"></particle-user-activity>
      </div>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="justify-start items-center full-grow-no-shrink-no-basis">
      <div *ngIf="!isReview"
           class="grid-toolbar-buttons-group-container m-r-20 flex flex-col justify-center items-start">
        <label class="component-label"> Actions</label>
        <div class="grid-toolbar-buttons-group m-t-7 flex flex-row justify-start items-center"
             style="position: relative;top: 2px">

          <div class="button-container pointer flex flex-row justify-start items-center">
            <div class="content m-r-10">Grid View</div>
            <mat-slide-toggle class="m-r-20"
                              [disabled]="!breadcrumbChildren || !breadcrumbChildren.length"
                              [checked]="isItemFormView"
                              (change)="toggleItemsView($event)">
              Form View
            </mat-slide-toggle>
            <div class="toolbar-separator"></div>
          </div>


          <div class="button-container flex flex-row justify-start items-center" *ngIf="canAddNewRow">
            <button mat-button class="orbitax-flat-button pointer" (click)="addNewRecord()"
                    particleAnalytics
                    analyticsCategory="file-manager-content"
                    analyticsAction="Accept Response">Add New Record
            </button>
            <div class="toolbar-separator"></div>

          </div>

          <mat-paginator
            *ngIf="breadcrumbs[breadcrumbs.length - 1] && breadcrumbs[breadcrumbs.length - 1].children"
            [length]="breadcrumbs[breadcrumbs.length - 1].children.length"
            [pageSize]="1"
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>
      </div>
      <div *ngIf="!isItemFormView"
           class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
        <label class="component-label"> Change Type</label>
        <div class="m-t-10 flex flex-row justify-start items-center">
          <div class="m-r-25 flex flex-row justify-start items-center">
            <div class="box value-change-box m-r-10"></div>
            <div class="content">Value Changed</div>
          </div>
          <div class="justify-start items-center">
            <div class="box new-record-box m-r-10"></div>
            <div class="content">New Record</div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
      <div class="flex flex-row justify-start items-center" *ngIf="isReview">
        <button mat-button class="reject-changes m-r-10" (click)="rejectResponse()"><i class="fas fa-times"></i>
          Reject
          Changes
        </button>
        <button mat-button class="submit-changes" (click)="acceptResponse()"><i class="fas fa-check"></i>
          Approve
          Changes
        </button>
      </div>
      <div *ngIf="!isReview">
        <button mat-button class="start-data-survey" (click)="submitResponse()"><i class="fal fa-play"></i>
          Submit
          Response
        </button>
      </div>
    </div>
  </div>
  <mat-sidenav-container *ngIf="!isItemFormView">
    <div class="center" *ngIf="isGridConfigReady">
      <div class="content-card mat-white-bg">
        <div [ngClass]="hasTabs ? 'content pos-relative' : 'content pos-relative m-30'" class="flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="executionSourceType"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onValueChange($event)"
                                   (fieldSectionChanged)="onFieldSectionChanged($event)"
                                   [rowClass]="rowCallback"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
  <particle-data-survey-response-form-view #surveyResponseForm
                                           *ngIf="isItemFormView && !hasFlowCharts"
                                           [itemId]="formViewItemId"
                                           [surveyId]="surveyId"
                                           [sectionType]="attachmentType"
                                           [sourceType]="executionSourceType"
                                           [executionId]="executionId"
                                           [userExecutionId]="surveyExecutionId"
                                           [userId]="userId"
                                           (saveChanged)="onFormSaveChange($event)"
  >

  </particle-data-survey-response-form-view>
  <particle-flow-chart-container *ngIf="isItemFormView && hasFlowCharts && formViewItemId"
                                 [surveyId]="surveyId"
                                 [surveyExecutionId]="surveyExecutionId"
                                 [flowChartId]="flowchartId"
                                 [hideFlowchartTabs]="false"
                                 [itemId]="formViewItemId">
  </particle-flow-chart-container>
</div>
